function ApiManagement() {
  return (
    <div>
      <h2>API Management</h2>
    </div>
  );
}

export default ApiManagement;
